import type { Theme } from 'foundations-theming';
import type {
  Action,
  Actions,
  ActionsMenuProps,
  NestedAction,
  ReferenceLayout,
} from './ActionsMenu.types';
import { isNested } from '../../utils/select-actionsmenu';

/**
 * Get padding values of the reference element, aka the trigger element
 * that toggles the menu.
 */
export const getReferencePadding = (theme: Theme) => {
  return {
    paddingBlock: theme.space[200],
    paddingInline: theme.space[300],
  };
};

export const getReferenceLayout = (
  referenceIndicator: ActionsMenuProps['referenceIndicator'],
  referenceText: ActionsMenuProps['referenceText']
): ReferenceLayout => {
  if (referenceIndicator && referenceText) {
    return 'indicator-text';
  } else if (referenceIndicator && !referenceText) {
    return 'indicator-only';
  } else {
    return 'text-only';
  }
};

export const getFlattenedActions = (
  actionsArray: ActionsMenuProps['actions']
): Actions => {
  return actionsArray.flatMap((currentAction) => {
    if (isNested(currentAction)) {
      const { subheading, actions } = currentAction as NestedAction;
      return [
        {
          text: subheading,
          value: subheading,
          isSubheading: true,
        },
        ...actions.map((action, index) => ({
          ...action,
          divider: index === actions.length - 1,
        })),
      ];
    } else {
      return [currentAction as Action];
    }
  });
};
